<script>
    export default {
        data () {
            return {
                cellTypeId: [
                    'local_versions__id',
                ],
                cellTypeGid: [
                    'versions__id',
                ],
                cellTypeText: [
                    'models__name',
                    'local_versions__name',
                    'prices__local_language_name',
                ],
                cellTypeNumber: [
                    'prices__price_incl_tax',
                    'prices__delivery_charges',
                    'prices__other_tax',
                    'core_specs__engine_capacity',
                    'local_specs__engine_power_kw',
                    'local_specs__engine_power_hp',
                    'local_specs__engine_power_rpm',
                    'core_specs__emission_co2',
                    'local_specs__traction_control_price',
                    'local_specs__brakes_abs_price',
                ],
                cellTypeDate: [
                    "prices__data_date",
                ],
                cellTypeCategory: [
                    "local_versions__catalog_category",
                ],
                cellTypeSelect: [
                    "prices__model_year",
                    "versions__limited_edition",
                    "local_specs__traction_control_avail",
                    "local_specs__brakes_abs_avail",
                    "prices__data_event",
                    "versions__vehicle_category",
                    "core_specs__gearbox_no_of_gears",
                    "core_specs__emission_class",
                    'prices__import_method',
                ],
                // Select fields
                cellTypeYear: [
                    "prices__model_year",
                ],
                cellTypeLimtedEdition : [
                    "versions__limited_edition",
                ],
                cellTypeOptionalExtras: [
                    "local_specs__traction_control_avail",
                    "local_specs__brakes_abs_avail",
                ],
                cellTypeDataStatus: [
                    "prices__data_event",
                ],
                cellTypeVehicleCategory: [
                    "versions__vehicle_category",
                ],
                cellTypeNumberGears: [
                    "core_specs__gearbox_no_of_gears",
                ],
                cellTypeEmissionsClass: [
                    "core_specs__emission_class",
                ],
                cellTypeImportMethod: [
                    'prices__import_method',
                ],
                cellWidthMap: {
                    local_versions__id: 5,
                    versions__id: 5,
                    models__name: 7,
                    prices__data_event: 3,
                    prices__model_year: 4,
                    versions__limited_edition: 2,
                    core_specs__engine_capacity: 4,
                    local_specs__engine_power_kw: 4,
                    local_specs__engine_power_hp: 4,
                    local_specs__engine_power_rpm: 4,
                    core_specs__emission_co2: 3,
                    core_specs__gearbox_no_of_gears: 2,
                    core_specs__emission_class: 3,
                    prices__import_method: 4,
                    prices__local_language_name: 10,
                }
            }
        },
        methods: {
            isFixed: function(cellKey) {
                var fixedCellPrefixes = [
                    "versions",
                    "models",
                    "brands",
                ];

                if (['versions__limited_edition', 'versions__vehicle_category'].includes(cellKey)) {
                    return false;
                }

                return fixedCellPrefixes.includes(cellKey.split("__")[0]) || cellKey === "local_versions__id";
            },
            isDatastatusSelect: function(cellKey) {
                return this.cellTypeDataStatus.includes(cellKey);
            },
            isOptionalExtraSelect: function(cellKey) {
                return this.cellTypeOptionalExtras.includes(cellKey);
            },
            bestCellWidth: function (itemValue, tag) {
                // console.log(tag+' len='+itemValue.length);
                let minWidth = 3;
                if (!itemValue) {
                    return minWidth + 'em';
                }
                let factor = 0.6;
                let itemTag = tag.split('__');
                itemTag = itemTag[0] + '__' + itemTag[1];
                /** Get the cell width preference from CellTypeMixin */
                let widthMap = this.cellWidthMap;
                if (widthMap.hasOwnProperty(itemTag)) {
                    minWidth = widthMap[itemTag];
                }
                /** Calculate the cell width based on its content */
                let contentLength = Math.round(itemValue.length * factor);
                if (contentLength > minWidth) {
                    minWidth = contentLength;
                }
                return minWidth + 'em';
            },

            getSelectOptions: function (cellKey) {
                if (this.cellTypeYear.includes(cellKey)) {
                    var years = Array();

                    for (let index = new Date().getFullYear() + 1; index >= new Date().getFullYear() - 9; index--) {
                        years.push({id: index, value: index});
                    }
                    return years;
                }

                if (this.cellTypeLimtedEdition.includes(cellKey)) {
                    return [
                        {id: "-", value: "-"},
                        {id: "Y", value: "Yes"},
                    ];
                }

                if (this.cellTypeOptionalExtras.includes(cellKey)) {
                    return [
                        {id: null, value: ""},
                        {id: "-", value: "Not Available"},
                        {id: "S", value: "Standard"},
                        {id: "O", value: "Option"},
                        {id: "P", value: "Pack"},
                        {id: "I", value: "Included Option"},
                    ];
                }

                if (this.cellTypeDataStatus.includes(cellKey)) {
                    return [
                        {id: "D", value: "Deleted"},
                        {id: "M", value: "Modelyear"},
                        {id: "N", value: "New"},
                        {id: "O", value: "Options"},
                        {id: "P", value: "Price only"},
                        {id: "R", value: "Replacement"},
                        {id: "S", value: "Specs"},
                        {id: "T", value: "Tax only"},
                        {id: "A", value: "Advanced info"}
                    ];
                }

                if (this.cellTypeVehicleCategory.includes(cellKey)) {
                    return [
                        {id: "SC", value: "Scooter"},
                        {id: "S3", value: "3-wheel scooter"},
                        {id: "LB", value: "Light bike"},
                        {id: "EN", value: "Enduro"},
                        {id: "CU", value: "Custom"},
                        {id: "NK", value: "Naked"},
                        {id: "AL", value: "All-round"},
                        {id: "SB", value: "Super bike"},
                        {id: "TB", value: "Touring"}
                    ];
                }

                if (this.cellTypeNumberGears.includes(cellKey)) {
                    return [
                        {id: null, value: ""},
                        {id: "2", value: "2"},
                        {id: "3", value: "3"},
                        {id: "4", value: "4"},
                        {id: "5", value: "5"},
                        {id: "6", value: "6"},
                        {id: "7", value: "7"},
                        {id: "8", value: "8"},
                        {id: "V", value: "V"}
                    ];
                }

                if (this.cellTypeEmissionsClass.includes(cellKey)) {
                    return [
                        {id: null, value: ""},
                        {id: "EU3", value: "EU3"},
                        {id: "EU4", value: "EU4"},
                        {id: "EU5", value: "EU5"},
                        {id: "G3", value: "G3"},
                        {id: "CN3", value: "CN3"}
                    ];
                }

                if (this.cellTypeImportMethod.includes(cellKey)) {
                    return [
                        {id: null, value: ""},
                        {id: "CBU", value: "CBU"},
                        {id: "SKD", value: "SKD"},
                        {id: "CKD", value: "CKD"},
                    ];
                }
            },
        },
    }
</script>
